<template>
  <div class="row">
    <div class="col-12 col-lg-6">
      <UserCard
        :userId="getUserId"
        :fullname="getFullname"
        :userImage="getUserImage"
        :size="70"
      >
        <div class="p-3">
          <StarIcon :points="myPoints" />
        </div>
      </UserCard>
    </div>
    <div class="col-12 col-lg-6">
      <GroupCardv2 v-bind="myGroup" :points="myGroup.pointsAllTime" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserCard from "@/components/activity/UserCard.vue";
import GroupCardv2 from "@/components/activity/GroupCardv2.vue";
import StarIcon from "@/components/activity/StarIcon.vue";

export default {
  name: "AchievementScoreboard",
  components: { UserCard, GroupCardv2, StarIcon },
  props: {
    myPoints: {
      type: Number,
      required: true
    },
    myGroup: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getFullname", "getUserId", "getUserImage"])
  }
};
</script>
